import styled from '@emotion/styled'
import { Button, Checkbox, Link, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { LOCAL_STORAGE_AGREEMENT_KEY } from 'constants/constants'
import { GitBook } from 'constants/externalLink'
import CoreModal from 'core/CoreModal'
import { ReactChild, useEffect, useState } from 'react'
import { ls } from 'services/localStorageService'

const CheckboxControl = styled(Box)`
  display: flex;
  justify-content: start;
  align-items: start;
  width: 100;
  padding: 7px 0px;
`

const _RiskAck = ['a', 'b'] as const
type RiskAck = typeof _RiskAck[number]

interface Props {
  onClose: () => void
  onProcess: () => void
}

const RiskAcknowledgeModal = ({ onClose, onProcess }: Props) => {
  const [checked, setChecked] = useState<{ [k in RiskAck]: boolean }>({
    a: false,
    b: false,
  })

  const handleOnCheck = (agreement: RiskAck) => {
    setChecked({ ...checked, [agreement]: !checked[agreement] })
  }

  const handleOnProcess = () => {
    if (!ValidChecked(checked)) return
    ls.set(LOCAL_STORAGE_AGREEMENT_KEY, JSON.stringify(checked))
    onProcess()
  }

  useEffect(() => {
    const _checked = ls.get(
      LOCAL_STORAGE_AGREEMENT_KEY,
      JSON.stringify(checked),
    )
    setChecked(JSON.parse(_checked))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Risks: { [k in RiskAck]: ReactChild } = {
    // a: (
    //   <Typography variant="body2" color="#4C4C4C">
    //     I understand that this contract was only partially audited by
    //     <Link
    //       href="https://zinstitute.net/"
    //       target="_blank"
    //       display="inline-block"
    //       px="2px"
    //     >
    //       The Z Institute
    //     </Link>
    //     .
    //   </Typography>
    // ),
    a: (
      <Typography variant="body2" color="#4C4C4C">
        I understand that there are
        <Link
          href={GitBook.smartContract}
          target="_blank"
          display="inline-block"
          px="2px"
        >
          smart contract
        </Link>
        risks and I will use at my own risk.
      </Typography>
    ),
    b: (
      <Typography variant="body2" color="#4C4C4C">
        I understand that there is a
        <Link
          href={GitBook.risk}
          target="_blank"
          display="inline-block"
          px="2px"
        >
          liquidation risk
        </Link>
        if my position is underwater.
      </Typography>
    ),
  }

  const Content = (
    <Box>
      <Typography variant="h5" pb="8px">
        Risk acknowledgement
      </Typography>
      {_RiskAck.map((r, i) => (
        <CheckboxControl sx={{ marginY: '9px' }} key={i}>
          <Checkbox
            checked={checked[r]}
            sx={{ width: '24px', height: '24px', marginRight: '12px' }}
            onChange={() => handleOnCheck(r)}
          />
          <Box display="flex" gap="3px">
            {Risks[r]}
          </Box>
        </CheckboxControl>
      ))}
      <br />
      <Button
        variant="contained"
        disabled={!ValidChecked(checked)}
        onClick={handleOnProcess}
        fullWidth
      >
        Proceed
      </Button>
    </Box>
  )

  return <CoreModal open content={Content} onClose={onClose} />
}

export default RiskAcknowledgeModal

const ValidChecked = (checked: { [k in RiskAck]: boolean }) => {
  return !_RiskAck.find((r) => !checked[r])
}
